// Utility function to lower the first character of a string
export function lowerFirstCharacter(str: string): string {
	if (!str) return str;
	return str.charAt(0).toLowerCase() + str.slice(1);
}
